import axios from "axios";

let url = require('url');
let _ = require('lodash');
import {HTTP} from './http'

const configuration = {
  // protocol: 'https',
  // host: 'dev.dncp.gov.py',
  // hostname: undefined, // ex. google
  // port: 443,
  casUrl: process.env.VUE_APP_CAS_URL,
  query: {
    service: process.env.VUE_APP_SERVICE_URL
  },
  paths: {
    validate: '/cas/validate',               // not implemented
    serviceValidate: '/cas/serviceValidate', // CAS 2.0
    proxyValidate: '/cas/proxyValidate',
    proxy: '/cas/proxy',
    login: '/cas/login',
    logout: '/cas/logout'
  }
};

export default {
  isAutenticated() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    // Se registra el ticket generado
    if (params.ticket) {
      sessionStorage.setItem('ticket', params.ticket);
    }
    let ticket = sessionStorage.getItem('ticket');
    return !!ticket;
  },

  async hasPermission() {
    return HTTP.get(`/cas/obtenerUsuario`)
  },
  getOptions() {
    let options = _.extend({}, configuration);
    let casUrl = new URL(options.casUrl);
    options.protocol = casUrl.protocol;
    options.host = casUrl.host;
    options.query = options.query || {};
    return options;
  },
  authenticate() {
    let options = this.getOptions();
    options.pathname = options.paths.login;
    window.location.replace(url.format(options));   // similar behavior as an HTTP redirect
  },
  logout() {
    sessionStorage.removeItem('ticket');
    sessionStorage.removeItem('usuario');
    sessionStorage.removeItem('payload');
    sessionStorage.removeItem('uoc');
    sessionStorage.removeItem('uoc_nombre');
    sessionStorage.removeItem('nombre_usuario');

    let options = this.getOptions();
    options.pathname = options.paths.logout;
    window.location.replace(url.format(options));   // similar behavior as an HTTP redirect
  },
  checkTicket() {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_BACKEND_URL}cas/validateTicket?ticket=${sessionStorage.getItem('ticket')}`) //El ticket ya se envía
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error)
          })
    });
  },
  async getUser() {
    let ticket = sessionStorage.getItem('ticket');
    // console.log(process.env.NODE_ENV);
    if (ticket) {
      await HTTP.get(`/cas/obtenerUsuario`) //El ticket ya se envía
          .then(response => {
            let payload = response.data;
            if (payload) {
              //let userMetadata = JSON.parse(atob(payload))
              let userMetadata = JSON.parse(decodeURIComponent(escape(window.atob( payload ))))
              sessionStorage.setItem('usuario', userMetadata.usuario);
              sessionStorage.setItem('uoc', userMetadata.convocante_id);
              sessionStorage.setItem('uoc_nombre', userMetadata.uoc);
              sessionStorage.setItem('nombre_usuario', userMetadata.nombre_usuario);
              sessionStorage.setItem('payload', payload);
            }
          })
          .catch(error => {
            console.log(error.response.data)
          })
    }
  }
}
